import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Fade, DialogContent, Dialog } from '@material-ui/core';
import ServiceList from './ServiceList';
import { FormattedMessage } from 'react-intl';
import { Scrollbars } from 'react-custom-scrollbars';
import HOCSectionLoader from '../HOC/HOCSectionLoader';
var isMounted = false;
class ServicePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            loaderMain: false,
            value: 0,
            phone: '',
            emailOtp: '',
            phoneOtp: '',
            showContent: 1,
            dashboardRedirect: false,
            providerServices: [],
            loader: true
        };
    }
    componentDidMount = async () => {
        isMounted = true;
        this.getData();
    };

    getData = () => {
        if (isMounted) {
            this.props.providerServiceListAction(
                { id: this.props.provider.key },
                this.onDone
            );
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }
    onDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            this.setState({ providerServices: data.data });
        }
    };
    handleClose = () => {
        this.props.close();
    };

    handleError = params => {
        this.setState(params);
    };

    render() {
        const { loader } = this.state;
        if (this.state.dashboardRedirect) {
            this.props.history.push({
                pathname: `/user/dashboard`
            });
        }

        return (
            <div>
                <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-modal"
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <form className="dialog-form">
                        <div
                            className="modal-header dir-pop-head"
                            style={{
                                backgroundColor: this.props.theme.palette
                                    .primary.main
                            }}
                        >
                            <h4>
                                {this.props.provider.businessName}{' '}
                                <FormattedMessage
                                    id="service.services"
                                    defaultMessage="Services"
                                />
                            </h4>
                        </div>
                        <div className="modal-body dir-pop-body">
                            <DialogContent className="service-from-body">
                                {/* <HOCSectionLoader loading={loader}> */}
                                <Scrollbars>
                                    {this.state.providerServices.map(
                                        service => (
                                            <ServiceList
                                                providerId={
                                                    this.props.provider.key
                                                }
                                                key={service.key}
                                                data={service}
                                            />
                                        )
                                    )}
                                </Scrollbars>
                                {/* </HOCSectionLoader> */}
                            </DialogContent>
                        </div>
                    </form>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(null, actions)
);
export default composedHOC(ServicePopup);



// WEBPACK FOOTER //
// ./src/components/Providers/ServicePopup.js